__turbopack_context__.v({
  "btn": "hide-and-seek-settings-module__zHGA_G__btn",
  "btnWrapper": "hide-and-seek-settings-module__zHGA_G__btnWrapper",
  "collectableInput": "hide-and-seek-settings-module__zHGA_G__collectableInput",
  "formContainer": "hide-and-seek-settings-module__zHGA_G__formContainer",
  "items": "hide-and-seek-settings-module__zHGA_G__items",
  "title": "hide-and-seek-settings-module__zHGA_G__title",
  "wrapperItems": "hide-and-seek-settings-module__zHGA_G__wrapperItems",
});
